module.exports = __webpack_public_path__ + "img/damuzhi.8b6371f3.png";